import { render, staticRenderFns } from "./TriadTimeStudy.vue?vue&type=template&id=5d5be72a&scoped=true"
import script from "./TriadTimeStudy.vue?vue&type=script&lang=js"
export * from "./TriadTimeStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5be72a",
  null
  
)

export default component.exports